import { Select } from "@mantine/core"
import { useTranslation } from "react-i18next"
import useSWR from "swr";
import { StaffApi } from "../../apis";
import HttpHandler from "../../utils/http-handler";
import { renderName } from "../../utils/render-name";
import { message } from "../../utils/message";

export function StaffForm({ id, values, setFieldValue, index }: { id: any; values: any; setFieldValue: any; index: any }) {
  const { t } = useTranslation(["common"])
  const { data } = useSWR(`/ord/staff/select/${id}/${index}`, async () => {
    try {
      let res = await StaffApi.select({ businessId: id[index]?.buyerBusinessId });
      return res;
    } catch (err) {
      message.error((err as HttpHandler)?.message!);
    }
  });

  return (
    <Select
      size="sm"
      value={values?.lines?.[index]?.receiverStaffId ?? null}
      onChange={(v) => setFieldValue(`lines.${index}.receiverStaffId`, v)}
      placeholder={t("common:filter.selectPlaceholder")}
      data={(data || []).map((c: any) => ({
        label: renderName(c),
        value: c.id,
      }))}
      clearable
    />
  );
}
